import { render } from "./SuccessOk.vue?vue&type=template&id=0a6f2175&scoped=true"
import script from "./SuccessOk.vue?vue&type=script&lang=js"
export * from "./SuccessOk.vue?vue&type=script&lang=js"

import "./SuccessOk.vue?vue&type=style&index=0&id=0a6f2175&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a6f2175"]])

export default __exports__